(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[801],{

/***/ 977:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign-up",
      function () {
        return __webpack_require__(1244);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ AuthLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/components/Navigation/Footer.tsx
var Footer = __webpack_require__(8942);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(8527);
// EXTERNAL MODULE: ./src/components/Layout/Container.tsx
var Container = __webpack_require__(5027);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(3918);
;// CONCATENATED MODULE: ./src/components/Navigation/AuthHeader.tsx






var Header = function() {
    var padding = (0,styled_components_browser_esm/* useTheme */.Fg)().padding;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        display: "flex",
        py: padding.lg,
        justifyContent: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/",
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                as: "a",
                cursor: "pointer",
                maxW: 200,
                w: "100%",
                pos: "relative",
                height: "40px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    layout: "fill",
                    src: "/images/logo-dark.png",
                    objectFit: "contain",
                    priority: true
                })
            })
        })
    });
};
/* harmony default export */ var AuthHeader = (Header);

// EXTERNAL MODULE: ./src/components/Layout/Default/styles.ts
var styles = __webpack_require__(8194);
;// CONCATENATED MODULE: ./src/components/Layout/Auth/index.tsx






var AuthLayout = function(param) {
    var children = param.children;
    var colors = (0,styled_components_browser_esm/* useTheme */.Fg)().colors;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* HeaderWrapper */.Pz, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthHeader, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                as: "main",
                pos: "relative",
                zIndex: 0,
                bg: colors.accent.beige,
                borderBottom: "1px solid ".concat(colors.geyser),
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* FooterWrapper */.V6, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
            })
        ]
    });
};


/***/ }),

/***/ 1244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ sign_up; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(8527);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/chakra-ui-form-control.esm.js
var chakra_ui_form_control_esm = __webpack_require__(9762);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/chakra-ui-input.esm.js
var chakra_ui_input_esm = __webpack_require__(4612);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js
var chakra_ui_button_esm = __webpack_require__(5193);
// EXTERNAL MODULE: ./src/components/Layout/Container.tsx
var Container = __webpack_require__(5027);
// EXTERNAL MODULE: ./src/context/AuthUserContext.tsx + 15 modules
var AuthUserContext = __webpack_require__(3913);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(3918);
;// CONCATENATED MODULE: ./src/components/Forms/Auth/SignUp/index.tsx










var SignUpForm = function() {
    var ref = (0,index_esm/* useForm */.cI)(), register = ref.register, handleSubmit = ref.handleSubmit, setError = ref.setError, _formState = ref.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    var createUserWithEmailAndPassword = (0,AuthUserContext/* useAuth */.a)().createUserWithEmailAndPassword;
    var colors = (0,styled_components_browser_esm/* useTheme */.Fg)().colors;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var email, password, user;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        email = data.email, password = data.password;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return createUserWithEmailAndPassword(email, password);
                    case 4:
                        user = _ctx.sent;
                        console.log({
                            user: user
                        });
                        _ctx.next = 12;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        if ((_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.code) === "auth/email-already-in-use") {
                            setError("email", {
                                message: "Email already in use."
                            });
                        }
                        console.log({
                            error: _ctx.t0
                        });
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8
                ]
            ]);
        }));
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        display: "flex",
        justifyContent: "center",
        p: "75px 0 150px 0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
            maxW: "500px",
            w: "100%",
            as: "form",
            onSubmit: handleSubmit(onSubmit),
            borderRadius: "4px",
            p: "35px 50px",
            bg: colors.white,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormControl */.NI, {
                    isInvalid: !!errors.fullName,
                    mb: "12px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_form_control_esm/* FormLabel */.lX, {
                            htmlFor: "fullName",
                            children: "Full Name"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_input_esm/* Input */.II, (0,_object_spread/* default */.Z)({
                            id: "fullName",
                            placeholder: "John Doe"
                        }, register("fullName", {
                            required: "This is required"
                        }))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_form_control_esm/* FormErrorMessage */.J1, {
                            children: errors.fullName && errors.fullName.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormControl */.NI, {
                    isInvalid: !!errors.email,
                    mb: "12px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_form_control_esm/* FormLabel */.lX, {
                            htmlFor: "email",
                            children: "Email"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_input_esm/* Input */.II, (0,_object_spread/* default */.Z)({
                            id: "email",
                            placeholder: "name@example.com",
                            type: "email"
                        }, register("email", {
                            required: "Name is required"
                        }))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_form_control_esm/* FormErrorMessage */.J1, {
                            children: errors.email && errors.email.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormControl */.NI, {
                    isInvalid: !!errors.password,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_form_control_esm/* FormLabel */.lX, {
                            htmlFor: "password",
                            children: "Password"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_input_esm/* Input */.II, (0,_object_spread/* default */.Z)({
                            id: "password",
                            type: "password",
                            placeholder: "Minimum 8 Characters"
                        }, register("password", {
                            required: "Password is required",
                            minLength: {
                                value: 8,
                                message: "Minimum length should be 8"
                            }
                        }))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_form_control_esm/* FormErrorMessage */.J1, {
                            children: errors.password && errors.password.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, {
                    mt: 4,
                    isLoading: isSubmitting,
                    type: "submit",
                    variant: "primary",
                    w: "100%",
                    children: "Submit"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Text */.xv, {
                    mt: "30px",
                    fontWeight: 500,
                    textAlign: "center",
                    children: [
                        "Already have an account?",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/sign-in",
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                as: "a",
                                color: "#3ba1df",
                                textDecoration: "underline",
                                children: "Log In"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/Layout/Auth/index.tsx + 1 modules
var Auth = __webpack_require__(1808);
;// CONCATENATED MODULE: ./src/pages/sign-up.tsx



var SignUp = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpForm, {});
};
SignUp.Layout = Auth/* AuthLayout */.g;
var __N_SSG = true;
/* harmony default export */ var sign_up = (SignUp);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [710,774,888,179], function() { return __webpack_exec__(977); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);